<template>
  <div class="container lms-wrapper-two">
    
    <student-nav />

    <div class="lms-content buddy-content" @click="closeLevel2()">
      <student-header class="filled" :navbarmode.sync="navbarMode" ref="lmsv4header" />
     
      <div class="lms-content-body" style="height: calc(100vh - 80px)">
        
      
      <vue-custom-scrollbar class="" style="height: calc(100vh - 80px);">
        <div class="container-fluid mg-y-20">
          <div class="d-flex align-items-center mg-b-20">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb breadcrumb-style4 mg-b-10">
                <!-- <li class="breadcrumb-item"><router-link :to="{ name: 'buddyParticipant' }" class="tx-11" style="color: #444">Onboarding</router-link></li> -->
                <li class="breadcrumb-item"><router-link :to="{ name: 'buddyAdminDashboard' }" class="tx-11" style="color: #444">Onboarding</router-link></li>
                <li class="breadcrumb-item active tx-14" aria-current="page">Buddy ажилтан</li>
              </ol>
            </nav>
            <div class="mg-l-auto d-flex align-items-center">
              <div @click="exportBuddies()" class="rounded bg-success pd-x-10 pd-y-8" role="button">
                <feather type="file" class="tx-white"></feather>
              </div>
              <div class="mg-x-5">
                <depart-cascader2 v-model="listFilter.departId" :key="listFilterDepartKey" @on-change="departListChanged" checkStrictly size="large" ></depart-cascader2>
              </div>
              <div class="tgggler">
                <div @click="bdyUpdate()" class="pd-x-20 pd-y-8" role="button">
                  <feather type="plus"></feather>
                  Buddy нэмэх
                </div>
              </div>
              <div v-if="buddiesFetched && buddiesAllCount>0 && buddiesAllCount!=buddies.length" class="tgggler mg-l-10">
                <div @click="init(true)" class="pd-x-20 pd-y-8" role="button">
                  <feather type="list"></feather>
                  Бүгд ({{ buddiesAllCount }})
                </div>
              </div>
            </div>
          </div>
          

          <table class="wd-100p tbl-buddy">
            <thead>
              <tr>
                <th>Овог, нэр
                  <feather @click="openFilterModal(1)" type="search" class="mg-l-5" role="button"></feather>
                </th>
                <th>
                  Домайн
                  <feather @click="openFilterModal(2)" type="search" class="mg-l-5" role="button"></feather>
                </th>
                <th>Buddy ажилтан болсон огноо</th>
                <th>Ажилд орсон огноо</th>
                <th>Buddy ажилтнаар ажилласан өдөр</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>
            <tbody class="bg-white">
              <tr @click="gotoBuddyDetail(b)" v-for="(b, bi) in buddies" role="button" :class="`${!b.isActiveBuddy?'active-buddy':''}`">
                <td>
                  <div class="d-flex mg-y-6">
                    <div class="mg-r-10">
                      <img :src="`${b.avator}`" class="wd-40 rounded-circle" />
                    </div>
                    <div>
                      <div>{{ getFullName(b) }}</div>
                      <div class="tx-color-03 tx-normal">
                        {{ getPozits(b) }}
                        <!-- <template v-if="b.parentDepart!=undefined">{{b.parentDepart.shortName}} - </template>{{b.depart.shortName}} - {{ b.position }} -->
                      </div>
                    </div>
                  </div>
                </td>
                <td>{{ b.loginName }}</td>
                <td>{{ b.buddyStartDate | moment('YYYY.MM.DD') }}</td>
                <td>{{ b.workStartDate | moment('YYYY.MM.DD') }}</td>
                <td>{{ b.buddyWorkedDays.toFixed(0) }}</td>
                <td class="cmd-buddy">
                  <div class="d-flex ht-40 justify-content-center align-items-center">
                    <feather @click.stop="bdyUpdate(b)" role="button" type="edit-3" style="width: 24px; height: 24px"></feather>
                    <feather @click.stop="bdyRmve(b)" role="button" type="trash" style="width: 24px; height: 24px; color:#E43055" class="mg-l-10"></feather>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="d-flex justify-content-end mg-t-10 pgr-outer">
            <b-pagination
              v-model="pager.currentPage"
              :total-rows="buddiesCount"
              :per-page="pager.perPage"
              @change="pageChanged"
              first-number
              last-number
              align="center"
            ></b-pagination>
          </div>

        </div>
      </vue-custom-scrollbar>
    </div>

      <vue-custom-scrollbar
        class="lms-sidebar-right"
      >
        <div class="lms-sidebar-right-header">
          <div class="pos-absolute r-20 t-20">
            <div :class="`dropdown dropdown-profile`" v-show="$route.name=='buddyParticipant'">
                <a href class="dropdown-link" data-toggle="dropdown">
                  <img :src="`${myResBaseUrl}v4-assets/icon1.png`" />
                </a>
                <div class="divide-y dropdown-menu dropdown-menu-right tx-13">
                  <router-link to="/lms/profile" class="dropdown-item pd-l-0-f mg-b-15" role="button">
                    <feather type="user" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Профайл
                  </router-link>
                  <a @click="logout" class="dropdown-item pd-l-0-f mg-t-0-f" role="button">
                    <feather type="log-out" class="ht-20-f mg-r-5" style="width: 20px; height: 20px;"></feather
                    >Гарах
                  </a>
                </div>
              </div>
          </div>
          <a >
            <part-user-sidebar :mustJoinCourses="mustJoinCourses"></part-user-sidebar>
          </a>
        </div>
        
        <div class="lms-sidebar-right-body">

          <vc-calendar is-expanded title-position="left" color="red" /> 
        </div>

        <div class="lms-sidebar-right-footer">
        </div>
      </vue-custom-scrollbar>
    </div>

    <b-modal v-model="mdlUpdateBuddy" hide-footer>
      <div class="form-group">
        <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Газар / Хэлтэс</label>
        <depart-cascader2 v-model="workerFilterParam.filter.departId" 
          :id="workerFilterParam.filter.departId"
           :disabled="isEditing"
        @on-change="departChanged" checkStrictly></depart-cascader2>
      </div>
      <div class="form-group">
        <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Албан тушаал</label>
        <input v-model="workerFilterParam.filter.position" type="text" class="form-control" placeholder="Албан тушаал оруулна уу">
      </div>
      <div class="form-group">
        <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Buddy ажилтан болсон огноо</label>
        <DatePicker
          v-model="buddyDates.buddyStartDate"
          placeholder="Огноо сонгоно уу"
          type="date"
          style="width: 100%"
          :format="'yyyy-MM-dd'"
          :value-format="'yyyy-MM-dd'"
        ></DatePicker>
      </div>
      <div v-if="isEditing" class="form-group">
        <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Buddy ажилтан дуусгавар болох огноо</label>
        <DatePicker
          v-model="buddyDates.buddyEndDate"
          placeholder="Огноо сонгоно уу"
          type="date"
          style="width: 100%"
          :format="'yyyy-MM-dd'"
          :value-format="'yyyy-MM-dd'"
        ></DatePicker>
      </div>

      <div v-if="isEditing">
        <div @click="selectAfter(isEditingLoginName)" class="btn btn-block btn-info">Хадгалах</div>
      </div>
      <div v-else class="form-group">
        <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Ажилтан</label>
        <Autocomplete
              size="small"
              placeholder="Хайх утгаа бичнэ үү"
              popper-class="my-autocomplete"
              v-model="workerFilterParam.filter.loginName"
              :fetch-suggestions="querySearch"
              @select="handleSelect"
              popper-append-to-body
              class="wd-100p"
            >
              <feather slot="append" :size="16" type="search"></feather>
              <template slot-scope="{ item }">
                <div class="d-flex align-items-center">
                  <img :src="`${item.avator}`" class="rounded wd-40 mg-r-10" />
                  <div>
                    
                    <div class="lh-2">{{ item.lastName.charAt(0).toUpperCase() + '.' }}{{ item.firstName }} ({{ item.loginName }})</div>
                    <div class="lh-2 text-muted overflow-hidden text-ellipsis" style="max-width: 200px;">
                      {{ item?.depart?.shortName }} - {{ item?.position }}
                    </div>
                  </div>
                  <div class="mg-l-auto btn btn-xs btn-primary">
                    Buddy нэмэх
                  </div>
                </div>
              </template>
            </Autocomplete>
      </div>

      
      
      <div>
        
      </div>
    </b-modal>

    <b-modal v-model="objFilterModal.modal" >
      <div v-if="objFilterModal.mode==1">
        <div class="form-group">
          <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Овог</label>
          <input v-model="listFilter.lastName" type="text" class="form-control" placeholder="Овог оруулна уу">
        </div>
        <div class="form-group">
          <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Нэр</label>
          <input v-model="listFilter.firstName" type="text" class="form-control" placeholder="Нэр оруулна уу">
        </div>
      </div>
      <div v-else-if="objFilterModal.mode==2">
        <div class="form-group">
          <label class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03">Домайн</label>
          <input v-model="listFilter.loginName" type="text" class="form-control" placeholder="Домайн оруулна уу">
        </div>
      </div>

      
      <template #modal-footer>
        <div class="btn-group">
          <button @click="objFilterModal.modal= false;" type="button" class="btn btn-white" data-dismiss="modal">Болих</button>
          <button @click="objFilterModal.modal= false; init()" type="button" class="btn btn-primary">Хайх</button>
        </div>
      </template>
    </b-modal>

    <file-dialog
        :show="fileDialog.show"
        :id="fileDialog.id"
        @on-hide="fileDialog.show = false"
      />

  </div>
</template>

<script>
import { mapActions } from "vuex";

import vueCustomScrollbar from "vue-custom-scrollbar";
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";



import { request } from "@/api/all";
import { getConfigValueByKey } from "@/libs/util";

import { localSave, localRead } from "@/libs/util";

const moment = require("moment");

var _ = require("lodash");

import "element-ui/lib/theme-chalk/index.css";
import { Notification, Autocomplete, MessageBox, Message, DatePicker } from "element-ui";

export default {
  components: {
    Autocomplete, MessageBox, DatePicker,Message,
    vueCustomScrollbar,
    departCascader: () => ({
      component: import("@/components/modules/hr/departCascader2"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    departCascader2: () => ({
      component: import("@/components/modules/hr/departCascader"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    userCover: () => ({
      component: import("@/views/modules/lms/components/userCover.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentHeader: () => ({
      component: import("@/views/modules/lms/student/components/header.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000
    }),
    studentNav: () => ({
      component: import("@/views/modules/lms/student/components/nav.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    studentCalendar: () => ({
      component: import("@/views/modules/lms/teacher/components/calendar.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    partUserSidebar: () => ({
      component: import( "@/views/modules/lms/student/parts/userSidebar.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    cardBuddy: () => ({
      component: import( "@/views/modules/lms/student/buddy/components/cardBuddy.vue" ),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  data() {
    return {
      myResBaseUrl: "https://res.gosmart.mn/",
      mdlUpdateBuddy: false,
      navbarMode: 0,
      mustJoinCourses: {
        all: 0,
        finished: 0,
      },
      buddyDates:{
        buddyStartDate: this.formatDate(new Date()),
        buddyEndDate: null
      },
      buddies: [],
      buddiesCount: null,
      buddiesAllCount: null,
      buddiesFetched: false,
      listFilterDepartKey: 0,
      pager:{
        perPage:10,
        currentPage: 1
      },
      listFilter:{
        departId: null,
        firstName: null,
        lastName: null,
        domain: null
      },
      workerFilterParam:{
        filter:{
          position: null,
          departId: null,
          loginName: null,
          isBuddy: false,
          statusCode: 'main'
        }
      },
      objFilterModal:{
        mode: null,
        modal: false
      },
      isEditing: false,
      fileDialog: {
        id: null,
        show: false,
      },
    };
  },
  // beforeCreate() {
  //   require('@/assets/scss/pages/learning.scss');
  // },
  created() {
    this.fetchResBase();
  },
  mounted() {
    this.init();
  },
  destroyed() {
    //this.toggleBodyClass("removeClass", "app-lms");
  },
  methods: {
    getPozits(task){
      let rv='';
      if(task.parentDepart!=undefined && task.parentDepart!=null){
        rv= task.parentDepart.shortName + ' - ';
      }
      rv+=task.depart.shortName
      if(task.position!=null && task.position!=''){
        rv +=' - '+task.position;
      }
      return rv;
    },
    openFile(id){
      this.fileDialog.id = id;
      this.fileDialog.show = true;
    },
    exportBuddies(){
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "buddy/admin/exportBuddies" },
        data: {
          filter:this.listFilter
        },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){
          this.openFile(res.data.file.id);
        }
      });
    },
    gotoBuddyDetail(b){
      this.$router.push({name: 'buddyAdminBuddyDetail',
        params:{
          id: b.id
        }
      });
    },
    bdyUpdate(b){
      // console.log('bdyUpdate',b);
      
      if(b!=undefined){
        this.isEditing= true;
        this.isEditingLoginName= b.loginName;
        this.workerFilterParam.filter.departId= b.depart.id;
        this.buddyDates.buddyStartDate= b.buddyStartDate;
        this.buddyDates.buddyEndDate= b.buddyEndDate;  
      }else{
        this.isEditing= false;
        this.isEditingLoginName= '';
        this.workerFilterParam.filter.departId= null;
        this.buddyDates.buddyStartDate= this.formatDate(new Date());
        this.buddyDates.buddyEndDate= null;  
      }
      
      this.mdlUpdateBuddy= true;
    },
    bdyRmve(b){
      // console.log('bdyRmve', b);
      MessageBox.confirm("Та устгахдаа итгэлтэй байна уу ?", "Санамж", {
        confirmButtonText: "Тийм",
        cancelButtonText: "Үгүй",
        type: "warning",
      })
        .then(() => {
          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "POST", url: "buddy/admin/removeBuddy" },
            data: {
              id: b.id,
            },
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if(res!=false){
              Message.success("Амжилттай устгалаа.");
              this.init();
            }
          });
        })
        .catch(() => {});
    },
    formatDate(date){
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    pageChanged(e){
      this.pager.currentPage = e;
      this.init();
    },
    openFilterModal(mode){
      this.objFilterModal.mode= mode;
      this.objFilterModal.modal= true;
    },
    getFullName(b){
      let rv=b.firstName.toUpperCase();
      if(b.lastName!=undefined && b.lastName!=null && b.lastName!='' && b.lastName.length){
        rv= b.lastName.charAt(0).toUpperCase() + '. ' +b.firstName;
      }
      return rv;
    },
    departListChanged(e){
      this.listFilter.departId= e;
      this.init();
    },
    selectAfter(loginName){
      this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "buddy/admin/updateBuddy" },
          data: {
            loginName: loginName,
            buddyStartDate: this.buddyDates.buddyStartDate,
            buddyEndDate: this.buddyDates.buddyEndDate,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if(res!=false){
            // console.log('updateBuddy', res);
            this.mdlUpdateBuddy= false;
            Message.success("Амжилттай.");
            this.init(true);
          }
        });
    },
    handleSelect(item){
      MessageBox.confirm("Та хадгалахдаа итгэлтэй байна уу ?", "Санамж", {
        confirmButtonText: "Тийм",
        cancelButtonText: "Үгүй",
        type: "warning",
      })
        .then(() => {
          this.selectAfter(item.loginName);
        })
        .catch(() => {});
    },
    querySearch(queryString, cb) {
      // if (queryString!=undefined && queryString.length >= 1) {
        if(this.workerFilterParam.filter.departId>0){
          if (queryString) {
            this.workerFilterParam.filter.loginName = queryString.toLowerCase();
          }

          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "POST", url: "buddy/admin/getWorkers" },
            data: this.workerFilterParam,
            store: this.$store,
          }).then((res) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if(res!=false){
              if(res.data.list.length==0){
                Message.error("Ажилтны илэрц олдсонгүй.");
              }
              // console.log('buddies', res.data);
              cb(res.data.list);
            }
          });
        }else{
          Message.error("Газар / хэлтэс сонгоно  уу.");
        }
      // }
    },
    departChanged(e){
      // console.log('departChanged', e);
      this.workerFilterParam.filter.departId= e;
      // if(e!=undefined && e>0){
      //   this.toggleBodyClass("addClass", "dynamic-locker");
      //   request({
      //     api: { method: "POST", url: "buddy/admin/getWorkers" },
      //     data: this.workerFilterParam,
      //     store: this.$store,
      //   }).then((res) => {
      //     this.toggleBodyClass("removeClass", "dynamic-locker");
      //     if(res!=false){
      //       // console.log('buddies', res.data);
      //       cb(res.data.list);
      //     }
      //   });
      // }
    },
    logout(){
      this.$refs.lmsv4header.logout();
    },
    fetchResBase() {
      if (
        this.$store.state.app.activeGroup.resBaseUrl != undefined &&
        this.$store.state.app.activeGroup.resBaseUrl != ""
      ) {
        this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
      }
    },
    ...mapActions(["handleAside", "resetResponsiveLayoutConfig", "handleMainLayoutConfig"]),
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    closeLevel2() {
      if (this.$store.state.app.responsiveLayout.level2.show)
        this.resetResponsiveLayoutConfig(document);
    },
    
    getConfigValueByKey(key) {
      return getConfigValueByKey(this.$store.state.app.groupSettings, key);
    },
    init(reset) {
      this.buddiesFetched= false;

      if(reset!=undefined && reset){
        this.listFilterDepartKey++;
        this.listFilter={
          departId: null,
          firstName: null,
          lastName: null,
          domain: null
        };

        this.pager= { perPage:10, currentPage: 1 };
      }
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "POST", url: "buddy/admin/getBuddies" },
        data: {
          pager:{
            skip: (this.pager.currentPage - 1) * this.pager.perPage,
            size: this.pager.perPage,
          },
          filter:this.listFilter
        },
        store: this.$store,
      }).then((res) => {
        this.buddiesFetched= true;
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if(res!=false){

          this.buddies = res.data.list;
          // this.buddies = _.orderBy(res.data.list, ["isActiveBuddy"], ["asc"]);

          this.buddiesCount= res.data.count;
          this.buddiesAllCount= res.data.allCount;
          // console.log('buddies', res.data);
        }
      });
    },
    
  },
};
</script>
<style lang="scss">
.tgggler{
  div {
    font-weight: 500;
    background: linear-gradient(135.15deg, #FD709A 2.15%, #E43055 65.39%, #F26E7A 98.4%);
    border-radius: 5px;
    color: white;
  }
}
</style>